import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb, Button, List, ConfigProvider, Empty } from 'antd'
import { Command, Edit, Plus, Trash } from 'react-feather'
import { getProjectData } from 'Services/WeaverUtils'
import { getDefaultDescription } from 'Services/ActionsPagesUtils'
import { ActionsPage } from 'Model'
import { Link, withRouter } from 'react-router-dom'
import WeaverService from 'Services/WeaverService'
import {
  EmptyContainer,
  PageContainer,
  StyledList,
  StyledFooter
} from '../shared'
import './index.scss'

renderEmpty = ->
  <EmptyContainer>
    <div />
    <Empty />
    <div />
  </EmptyContainer>

ActionItem = ({ Icon, fn, rest... }) ->
  <Button
    type="text"
    icon={<Icon style={{ height: 20 }} />}
    size="small"
    disabled={!WeaverService.userCanEdit()}
    { rest... }
  />

ActionsPages = ({ match, history, currentProject }) ->

  { path, params: { spaceId }} = match
  [isLoading, setIsLoading] = useState(true)
  [listData, setListData] = useState([])

  useEffect( ->
    ( ->
      loadActionsPages()
    )()
    undefined
  , [currentProject])

  loadActionsPages = ->
    setIsLoading(true)
    pages = await ActionsPage.list()
    setListData(_.orderBy(pages.map((actPage) -> actPage.toPlainObj()), 'title'))
    setIsLoading(false)

  destroy = ({ key }) ->
    setIsLoading(true)
    item = await ActionsPage.load(key)
    await item.destroy()
    loadActionsPages()

  <PageContainer>
    <Breadcrumb style={{ margin: 20, marginBottom: 0 }}>
      <Breadcrumb.Item>
        { Weaver.getInstance().currentProject()?.name() }
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to="/#{ spaceId }/settings/services">
          Services
        </Link>
      </Breadcrumb.Item>
    </Breadcrumb>
    <ConfigProvider renderEmpty={renderEmpty}>
      <StyledList
        itemLayout="horizontal"
        size="large"
        dataSource={listData}
        loading={isLoading}
        className="action-pages-list-container"
        renderItem={(item) -> (
          <List.Item
            key={item.key}
            actions={[
              <ActionItem
                Icon={Edit}
                onClick={ -> history.push("/#{ spaceId }/settings/services/#{ item.key }")}
                type="link"
              />,
              <ActionItem
                Icon={Trash}
                onClick={ -> destroy(item)}
                danger
              />
            ]}
          >
            <List.Item.Meta
              avatar={<Command />}
              title={item.title}
              description={item.serviceName or <i>Plugin not set.</i>}
            />
            <div style={{ maxWidth: '33%' }}>{ item.description or getDefaultDescription(item) }</div>
          </List.Item>
        )}
      />
    </ConfigProvider>
    <StyledFooter>
      <Button
        icon={<Plus style={{ height: 16, margin: '-3px 3px' }} />}
        type="primary"
        onClick={ -> history.push("/#{ spaceId }/settings/services/new")}
        shape="round"
        size="large"
        disabled={!WeaverService.userCanEdit()}
      >
        Add a new service
      </Button>
    </StyledFooter>
  </PageContainer>

mapStateToProps = ({ projects: { currentProject }}) -> { currentProject }

export default connect(mapStateToProps)(withRouter(ActionsPages))